import { ComponentPropsWithRef, FC, Ref } from "react";

import { motion } from "framer-motion";

import { IModalTransitionVariants } from "./Modal";

interface IProps extends ComponentPropsWithRef<typeof motion.div> {
  variants: IModalTransitionVariants;
  ref?: Ref<HTMLDivElement>;
}

export const ModalOverlay: FC<IProps> = ({ variants, children, ref, ...props }) => {
  const variantsProps = {
    initial: "hidden",
    animate: "visible",
    exit: "hidden",
    variants,
  };

  return (
    <motion.div ref={ref} {...props} {...variantsProps}>
      {children}
    </motion.div>
  );
};
